var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security_icon",
    "data-name": "security icon",
    transform: "translate(-12 -750)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 32,
    height: 32,
    transform: "translate(12 750)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M14467,18903h-12a3.005,3.005,0,0,1-3-3v-10a3,3,0,0,1,3-3h12a3,3,0,0,1,3,3v10A3,3,0,0,1,14467,18903Zm-6-10a2,2,0,1,0,2,2A2,2,0,0,0,14461,18893Z",
    transform: "translate(-14433 -18125)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    d: "M5,2A3,3,0,0,0,2,5V8A3,3,0,0,0,8,8V5A3,3,0,0,0,5,2M5,0a5,5,0,0,1,5,5V8A5,5,0,0,1,0,8V5A5,5,0,0,1,5,0Z",
    transform: "translate(23 754)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.d402e353.svg";
export { ForwardRef as ReactComponent };